import { takeEvery } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { httpError as httpErrorAction } from '../actions';
import { DATA_LOAD_ERROR } from '../constants/actionTypes';

function *_handleServerErrors({payload:{resource,error,failedAction}}) {
    if (!error.response || error.response.status === 401) {
        yield put(httpErrorAction.http401(error, failedAction));
    }
}


export function *httpError() {
    yield takeEvery(DATA_LOAD_ERROR, _handleServerErrors);
}
